import { render } from "./VillaAssign.vue?vue&type=template&id=a6f0f5f2&scoped=true"
import script from "./VillaAssign.vue?vue&type=script&lang=js"
export * from "./VillaAssign.vue?vue&type=script&lang=js"

import "./VillaAssign.vue?vue&type=style&index=0&id=a6f0f5f2&scoped=true&lang=css"

import exportComponent from "E:\\sanket\\rio\\rio_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6f0f5f2"]])

export default __exports__